import * as React from "react";
import { type FC } from "react";
import { Gapped } from "react-ui";

import { Caption, Row } from "../FiasFnsManualEditor.styles";
import { AddressLevel } from "../../../FiasInput/Types/FiasTypes";
import { konturFiasAddressAbbreviations } from "../../../FiasInput/Utils/FiasAbbriviations/FilteredAbbreviations";

import { AddressField } from "./AddressField";
import { AddressTypeField } from "./AddressTypeField";
import { Control } from "./controlsPaths";

interface AddressRowProps {
    caption: string;
    fullSizeAbbreviation: boolean;
    level: AddressLevel;
    type: string;
    name: string;
    typePlaceholder: string;
    namePlaceholder: string;
    typeTid: string;
    nameTid: string;
    controlType: Control;
    onTypeChange: (next: string) => void;
    onNameChange: (next: string) => void;
}

export const AddressRow: FC<AddressRowProps> = props => (
    <Row>
        <Caption>{props.caption}</Caption>
        <Gapped>
            <AddressTypeField
                width={80}
                maxLength={50}
                value={props.type}
                placeholder={props.typePlaceholder}
                data-tid={props.typeTid}
                fullSize={props.fullSizeAbbreviation}
                controlType={props.controlType}
                onChange={props.onTypeChange}
                getSuggests={getTypeSuggests(props.level)}
            />

            <AddressField
                width={260}
                maxLength={255}
                value={props.name}
                placeholder={props.namePlaceholder}
                data-tid={props.nameTid}
                onChange={props.onNameChange}
            />
        </Gapped>
    </Row>
);

export const getTypeSuggests =
    (level: AddressLevel, max: number = 10) =>
    async (query: string) =>
        konturFiasAddressAbbreviations
            .filter(x => x.level === level && x.fullName.toLowerCase().includes(query.toLowerCase()))
            .slice(0, max);
